import { SpaceType } from "../../_types/space-type";

export class Equipment {
  id: number;
  name: string;
  type: SpaceType;
  iconName?: string;
}
export class EquipmentIcon {
  name: string;
  iconName: string;
  value: string;
  icon: string;
  SpaceType: SpaceType;
}
